<template>
  <div class="algolia-result-item">
    <YorkbbsImage class="info-cover" animation fit="contain" target="_blank" :src="coverImage | webpFormat(200)"
      :link="detailURL" @click="$emit('clickResult', 'click result to img')" v-if="!(payType == 4 && info.category_type_name_en == 'server')"></YorkbbsImage>
    <div class="item-infos">
      <div class="main-warp">
        <div class="lf-infos">
          <h2>
            <a class="info-title__wrapper" target="_blank" :href="detailURL"
              @click="$emit('clickResult', 'click result to title')">
              <img class="info-label__optimized" :src="require('@/assets/images/info/optimized.png')" alt="优选"
                v-if="isOptimized" />
              <span class="closure" v-if="permanentClosure">【永久歇业】 </span>
              <span class="info-shop" v-if="shopCnName" v-html="shopCnName"></span>
              <span v-if="shopEnName">&nbsp;</span>
              <span class="info-shop" v-if="shopEnName" v-html="shopEnName"></span>
              <span class="info-divider" v-if="shopCnName"></span>
              <span class="info-title" v-html="title"></span>

              <img class="info-label__vip" :src="require('@/assets/images/info/vip.png')" alt="VIP" v-if="isVip" />
            </a>
          </h2>
          <!-- 板块列表 美食类显示 -->
          <ul class="info-topic__list" v-if="topics.length">
            <li class="info-topic__item" v-for="(item, i) in topics" :key="i" v-html="item.value"></li>
          </ul>

          <!-- 联系人 非美食类显示 -->
          <div class="info-username" v-if="contactName && serviceType">联系人：<span v-html="contactName"></span></div>

          <!-- 地址 -->
          <div class="info-address" v-if="_address" v-html="_address"></div>

          <div class="info-status-tags">
            <!-- 关店状态 -->
            <!-- <div class="info-status__close" v-if="[1, 2].includes(businessFlag) || businessStatus == 0">Closed</div> -->
            <!-- 标签列表 -->
            <ul class="info-tag__list">
              <li class="info-tag__item" v-for="(item, i) in tags" :key="i" v-html="item.value"></li>
            </ul>
          </div>
        </div>
        <div class="lr-zone">
          <!-- 排名 -->
          <!-- <div class="info-rank" v-if="isVip">{{ info.__position }}</div> -->

          <!-- 联系电话 -->
          <a class="info-title__wrapper" target="_blank" :href="detailURL">
            <el-button class="button-tel" type="primary">
              <i class="yk-info_phone"></i>
              <span>{{ contactNumber | phoneFormat }}</span>
            </el-button>
          </a>


        </div>
      </div>
      <div class="info-image__list" v-if="isOptimized && listImage.length">
        <YorkbbsImage class="info-image__item" v-for="(item, i) in listImage.slice(0, 5)" :key="i" :src="item"
          animation></YorkbbsImage>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'AlgoliaResultItem',
  props: ['info', 'algoliaSendEvent'],

  computed: {
    // 付费类型
    payType() {
        return this.info.paytype;
    },  
    // 是否是美食版块
    isFoodTopic() {
      return this.info.post_type === 2;
    },

    coverImage() {
      return this.info.logo || this.info.cover_image|| this.info.image || '';
    },
    // 付费类型
    payType() {
      return this.info.paytype;
    },
    detailURL() {
      return this.info.url;
    },
    // 信息标题
    title() {
      return this.info._highlightResult.title.value;
    },
    // 商家中文名
    shopCnName() {
      return this.info.chinesename === this.title ? '' : this.info._highlightResult.chinesename.value;
    },
    shopEnName() {
      var isShow = this.info._highlightResult.englishname.matchedWords || [];
      if (isShow) {
        return this.info._highlightResult.englishname.value;
      } else {
        return '';
      }

    },
    // 是否是优选信息
    isOptimized() {
      return this.info.selected === 1;
    },
    // 是否是VIP
    isVip() {
      // 时长付费或竞价付费的都是VIP
      return this.info.paytype === 1 || this.info.paytype === 2;
    },
    // 联系人
    contactName() {
      return this.info._highlightResult.contact.value;
    },
    // 联系电话
    contactNumber() {
      return (this.info.phone || '').replace(/\D/g, '');
    },
    // 联系电话
    _contactNumber() {
      return this.contactNumber.slice(0, 3) + '-***-' + this.contactNumber.slice(-4);
    },
    // 地址
    address() {
      return this.info._highlightResult.address.value || '';
    },
    cityName() {
      return this.info._highlightResult.city.value || '';
    },
    postcode() {
      return this.info._highlightResult.postcode.value || '';
    },
    _address() {
      return [this.address, this.cityName, this.postcode].filter(item => !!item).join(', ');
    },
    // 标签
    tags() {
      let result = [];
      result = result.concat(this.info._highlightResult.categorytag || []);
      result = result.concat(this.info._highlightResult.storetag || []);

      return result.filter(item => item.matchedWords.length > 0);
    },
    // 图片集
    listImage() {
      return this.info.selected_images || [];
    },
    // 版块
    topics() {
      var list = [].concat(this.info._highlightResult.category || [], this.info._highlightResult.subcategory || []);
      return list.filter(item => item.matchedWords.length > 0);
    },
    //永久歇业
    permanentClosure() {
      return this.info.status === -5;
    },

    //服务行业
    serviceType() {
      return this.info.post_type === 1;
    }
  },
  data() {
    return {
      telVisible: false,
    }
  },

}
</script>
<style>
.algolia-result-item em {
  background: #FFF300;
  font-style: normal;
}
</style>
<style scoped>
.algolia-result-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid #eee;
}

/* .algolia-result-item:hover {
    background-color: #f8f8f8;
  } */


.info-cover {
  width: 160px;
  margin-right: 20px;
}

.info-cover {
  width: 160px;
  height: 120px;
  border-radius: 4px;
  border: 1px solid #eee;
  margin-right: 20px;
}

.item-infos {
  flex: 1;
}

.main-warp {
  display: flex;
}

.main-warp .lr-zone {
  width: 180px;
  position: relative;
  display: flex;
  align-items: center;
}

.main-warp .lr-zone .el-button {
  width: 100%;
}

.main-warp .lf-infos {
  flex: 1;
  padding-right: 20px;
}

.info-title__wrapper {
  display: block;
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 10px;
  font-weight: normal;
}

.info-title__wrapper:hover {
  color: #e43a3a;
}

.info-label__optimized {
  width: 30px;
  vertical-align: middle;
  margin-right: 5px;
}

.info-label__vip {
  width: 18px;
  vertical-align: middle;
  margin-left: 5px;
}

.closure {
  font-size: 18px;
  font-weight: 600;
  vertical-align: middle;
  color: #e43a3a;
}

.info-shop {
  font-size: 18px;
  font-weight: 600;
  vertical-align: middle;
}

.info-divider {
  display: inline-block;
  height: 12px;
  border-left: 1px solid #999;
  margin: 0 10px;
  vertical-align: middle;
}

.info-title {
  font-size: 18px;
  vertical-align: middle;
}

.info-username {
  font-size: 14px;
  line-height: 20px;
  color: #333;
  margin-bottom: 10px;
}

.info-address {
  font-size: 14px;
  line-height: 20px;
  color: #333;
  margin-bottom: 12px;
}

.info-status-tags {
  display: flex;
}

.info-tag__list {
  display: flex;
  flex-wrap: wrap;
  max-height: 64px;
  overflow: hidden;
}

.info-tag__item {
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin-right: 15px;
  margin-bottom: 12px;
}

.info-image__list {
  display: flex;
  margin-top: 20px;
}

.info-image__item {
  width: 120px;
  height: 75px;
  border-radius: 4px;
}

.info-image__item:not(:first-child) {
  margin-left: 10px;
}

.info-rank {
  width: 30px;
  height: 35px;
  background-color: #f8f8f8;
  border-radius: 15px;
  font-size: 20px;
  color: #b9b9b9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: -4px;
  z-index: 1;
}

.info-tel {
  background-color: transparent;
  border: 0 none;
  color: #111;
  font-size: 18px;
  font-weight: 500;

}

.info-tel i {
  font-size: 16px;
  margin-right: 7px;
}

.button-tel {
  font-size: 18px;
}

.button-tel i {
  margin-right: 7px;
}

.button-view {
  font-size: 12px;
  line-height: 17px;
  color: #999;
  margin-left: 43px;
}

.info-topic__list {
  display: flex;
  flex-wrap: wrap;
}

.info-topic__item {
  font-size: 14px;
  line-height: 20px;
  color: #333;
  margin-right: 15px;
  margin-bottom: 10px;
}

.info-label__unauth {
  display: inline-block;
  font-size: 12px;
  line-height: 22px;
  padding: 0 7px;
  color: #666;
  background-color: #f8f8f8;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 5px;
}
</style>